import { isPublicDiscoverPrivacy } from './discoverVisibility';

export function isPublicDiscoverMarker(marker) {
    return isPublicDiscoverPrivacy(marker?.privacy);
}

export function filterPublicDiscoverMarkers(markers) {
    if (!Array.isArray(markers)) {
        return [];
    }
    return markers.filter(isPublicDiscoverMarker);
}
